export var uiCheckCircleSolid = [
    'M14 8C14 11.31 11.31 14 8 14C4.69 14 2 11.31 2 8C2 4.69 4.69 2 8 2C11.31 2 14 4.69 14 8ZM7.31 11.18L11.76 6.73C11.91 6.57 11.91 6.33 11.76 6.18L11.21 5.63C11.06 5.48 10.81 5.48 10.66 5.63L7.03 9.26L5.34 7.57C5.19 7.41 4.94 7.41 4.79 7.57L4.24 8.11C4.09 8.26 4.09 8.51 4.24 8.66L6.76 11.18C6.91 11.33 7.15 11.33 7.31 11.18Z',
];
